import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: "When is the RSVP deadline?",
      answer: "Please RSVP by October 2026."
    },
    {
      question: "What should I wear?",
      answer: "Formal attire please."
    },
    {
      question: "Can I take photos during the ceremony?",
      answer: "We're having an unplugged ceremony - we kindly ask that you put away your phones and cameras during the ceremony itself. Our professional photographer will capture everything! Feel free to take as many photos as you'd like during the reception and other events."
    }
  ];

  return (
    <section id="faq" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-center text-wedding-navy mb-3 md:mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-center text-gray-600 text-sm sm:text-base mb-8 md:mb-12 max-w-2xl mx-auto px-2">
          Everything you need to know about celebrating with us in Punta Cana
        </p>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-wedding-cream rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center hover:bg-wedding-gold hover:bg-opacity-10 transition-colors"
              >
                <span className="font-semibold text-wedding-navy pr-4 sm:pr-8 text-sm sm:text-base">
                  {faq.question}
                </span>
                <svg
                  className={`w-4 h-4 sm:w-5 sm:h-5 text-wedding-gold flex-shrink-0 transition-transform ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              {openIndex === index && (
                <div className="px-4 sm:px-6 pb-3 sm:pb-4 text-gray-700 text-sm sm:text-base">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 text-center px-4">
          <p className="text-gray-600 mb-3 md:mb-4 text-sm sm:text-base">Still have questions?</p>
          <button
            onClick={() => {
              window.dispatchEvent(new CustomEvent('openContactModal'));
            }}
            className="bg-wedding-gold text-white px-5 sm:px-6 py-2 sm:py-3 text-sm sm:text-base rounded-full font-semibold hover:bg-opacity-90 transition-all transform hover:scale-105"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
